var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.891.977a.58.58 0 0 1 .575.515l.004.068-.001.475h2.364c.602 0 1.097.452 1.16 1.032l.007.126v8.65c0 .639-.522 1.157-1.167 1.157H1.167A1.162 1.162 0 0 1 0 11.843v-8.65c0-.64.522-1.157 1.167-1.157l2.667-.001V1.56c0-.322.26-.583.579-.583a.58.58 0 0 1 .575.515l.004.068-.001.475h4.321V1.56c0-.322.26-.583.58-.583zM1.166 6.874v4.969h11.667V6.875l-.05.003H1.217l-.051-.004zm11.667-3.681-2.364-.001V5.72h2.314l.05.004V3.193zm-8.999-.001H1.167l-.001 2.531.051-.002 2.617-.001V3.192zM9.312 5.72V3.192H4.991V5.72h4.321z"
  })));
};

export default SvgCalendar;